import type { FaireProductEntity } from "../../entity_types/product";

export const p_ehuubstvwj: FaireProductEntity = {
  token: "p_ehuubstvwj",
  type: "product",
  name: 'Brass Frame 5"x3" Horizontal',
  brandName: "Sugarboo & Co",
  imageUrl:
    "https://cdn.faire.com/fastly/302e0f53c7e73c5c309da5889242d55cc2aed6d664993a3f2e677af156603245.jpeg",
  priceDollars: 7.5,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/5ae22639aaeff650bcc0193cfbae5f26c69f3c1087674c899d0fdcbf658612a3.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
